var _style, _defs, _defs2, _path, _defs3, _path2, _defs4, _path3, _defs5, _path4, _defs6, _path5, _defs7, _path6, _defs8, _path7, _defs9, _path8, _defs10, _path9, _defs11, _path10, _defs12, _path11, _defs13, _path12, _defs14, _path13, _defs15, _polygon, _defs16, _polygon2, _defs17, _path14, _defs18, _defs19, _path15, _defs20, _path16, _defs21, _path17, _defs22, _path18, _defs23, _path19, _defs24, _path20, _defs25, _defs26, _path21, _defs27, _path22, _defs28, _path23, _defs29, _path24, _defs30, _path25, _defs31, _path26, _defs32, _path27, _defs33, _path28, _defs34, _path29, _defs35, _path30, _defs36, _path31, _defs37, _path32, _defs38, _path33, _defs39, _path34, _defs40, _path35, _defs41, _path36, _defs42, _path37, _defs43, _path38, _defs44, _path39, _defs45, _path40, _defs46, _path41, _defs47, _path42, _defs48, _path43, _defs49, _path44, _defs50, _path45, _defs51, _path46, _defs52, _path47, _defs53, _path48, _defs54, _path49, _defs55, _path50, _defs56, _path51, _defs57, _defs58, _path52, _defs59, _path53, _defs60, _path54, _defs61, _path55, _circle, _defs62, _defs63, _path56, _path57, _path58, _path59, _path60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 100",
    style: {
      enableBackground: "new 0 0 99 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t.st3{clip-path:url(#SVGID_4_);fill:#F2F2F2;}\r\n\t.st4{clip-path:url(#SVGID_6_);fill:#F2F2F2;}\r\n\t.st5{clip-path:url(#SVGID_8_);fill:#F2F2F2;}\r\n\t.st6{clip-path:url(#SVGID_10_);fill:#F2F2F2;}\r\n\t.st7{clip-path:url(#SVGID_12_);fill:#F2F2F2;}\r\n\t.st8{clip-path:url(#SVGID_14_);fill:#F2F2F2;}\r\n\t.st9{clip-path:url(#SVGID_16_);fill:#F2F2F2;}\r\n\t.st10{clip-path:url(#SVGID_18_);fill:#F2F2F2;}\r\n\t.st11{clip-path:url(#SVGID_20_);fill:#F2F2F2;}\r\n\t.st12{clip-path:url(#SVGID_22_);fill:#F2F2F2;}\r\n\t.st13{clip-path:url(#SVGID_24_);fill:#FF7900;}\r\n\t.st14{clip-path:url(#SVGID_26_);fill:#F99012;}\r\n\t.st15{clip-path:url(#SVGID_28_);fill:#FFA932;}\r\n\t.st16{clip-path:url(#SVGID_30_);fill:#FF7900;}\r\n\t.st17{clip-path:url(#SVGID_32_);fill:#E56700;}\r\n\t.st18{clip-path:url(#SVGID_34_);fill:#183962;}\r\n\t.st19{clip-path:url(#SVGID_36_);}\r\n\t.st20{clip-path:url(#SVGID_38_);fill:#F2F2F2;}\r\n\t.st21{clip-path:url(#SVGID_40_);fill:#F2F2F2;}\r\n\t.st22{clip-path:url(#SVGID_42_);fill:#F2F2F2;}\r\n\t.st23{clip-path:url(#SVGID_44_);fill:#F2F2F2;}\r\n\t.st24{clip-path:url(#SVGID_46_);fill:#F2F2F2;}\r\n\t.st25{clip-path:url(#SVGID_48_);fill:#F2F2F2;}\r\n\t.st26{clip-path:url(#SVGID_50_);}\r\n\t.st27{clip-path:url(#SVGID_52_);fill:#EBC18A;}\r\n\t.st28{clip-path:url(#SVGID_54_);fill:#EBC18A;}\r\n\t.st29{clip-path:url(#SVGID_56_);fill:#E5B379;}\r\n\t.st30{clip-path:url(#SVGID_58_);fill:#5F4002;}\r\n\t.st31{clip-path:url(#SVGID_60_);fill:#442D00;}\r\n\t.st32{clip-path:url(#SVGID_62_);fill:#442D00;}\r\n\t.st33{clip-path:url(#SVGID_64_);fill:#442D00;}\r\n\t.st34{clip-path:url(#SVGID_66_);fill:#FFE81D;}\r\n\t.st35{clip-path:url(#SVGID_68_);fill:#FFD800;}\r\n\t.st36{clip-path:url(#SVGID_70_);fill:#FFD800;}\r\n\t.st37{clip-path:url(#SVGID_72_);fill:#FFD800;}\r\n\t.st38{clip-path:url(#SVGID_74_);fill:#FFD800;}\r\n\t.st39{clip-path:url(#SVGID_76_);fill:#FFD800;}\r\n\t.st40{clip-path:url(#SVGID_78_);fill:#FFD800;}\r\n\t.st41{clip-path:url(#SVGID_80_);fill:#A5CE39;}\r\n\t.st42{clip-path:url(#SVGID_82_);fill:#96C000;}\r\n\t.st43{clip-path:url(#SVGID_84_);fill:#96C000;}\r\n\t.st44{clip-path:url(#SVGID_86_);fill:#96C000;}\r\n\t.st45{clip-path:url(#SVGID_88_);fill:#96C000;}\r\n\t.st46{clip-path:url(#SVGID_90_);fill:#96C000;}\r\n\t.st47{clip-path:url(#SVGID_92_);fill:#96C000;}\r\n\t.st48{clip-path:url(#SVGID_94_);fill:#96C000;}\r\n\t.st49{clip-path:url(#SVGID_96_);fill:#FF554C;}\r\n\t.st50{clip-path:url(#SVGID_98_);fill:#F73E30;}\r\n\t.st51{clip-path:url(#SVGID_100_);fill:#EBC18A;}\r\n\t.st52{clip-path:url(#SVGID_102_);fill:#E5B379;}\r\n\t.st53{clip-path:url(#SVGID_104_);fill:#FDE3C7;}\r\n\t.st54{clip-path:url(#SVGID_106_);fill:#FDE3C7;}\r\n\t.st55{clip-path:url(#SVGID_108_);fill:#FDE3C7;}\r\n\t.st56{clip-path:url(#SVGID_110_);fill:#FDE3C7;}\r\n\t.st57{clip-path:url(#SVGID_112_);fill:#FDE3C7;}\r\n\t.st58{clip-path:url(#SVGID_114_);}\r\n\t.st59{clip-path:url(#SVGID_116_);fill:#FFE700;}\r\n\t.st60{clip-path:url(#SVGID_118_);fill:#FFD300;}\r\n\t.st61{clip-path:url(#SVGID_120_);fill:#915100;}\r\n\t.st62{clip-path:url(#SVGID_122_);fill:#915100;}\r\n\t.st63{fill:#5EA3FF;}\r\n\t.st64{clip-path:url(#SVGID_124_);}\r\n\t.st65{clip-path:url(#SVGID_126_);fill:#F3FCFF;}\r\n\t.st66{clip-path:url(#SVGID_126_);fill:#D2F7FF;}\r\n\t.st67{clip-path:url(#SVGID_126_);fill:#85E0FF;}\r\n\t.st68{clip-path:url(#SVGID_126_);fill:#52D3FF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_83_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-17.9,47.8c0,37.4,30.3,67.6,67.6,67.6s67.6-30.3,67.6-67.6c0-37.4-30.3-67.6-67.6-67.6 S-17.9,10.5-17.9,47.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.6,105h19.2c1.9,0,3.5-1.6,3.5-3.5l0,0c0-1.9-1.6-3.5-3.5-3.5H82.6c-1.9,0-3.5,1.6-3.5,3.5l0,0 C79.1,103.5,80.7,105,82.6,105"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.2,105h7.5c1.9,0,3.5-1.6,3.5-3.5l0,0c0-1.9-1.6-3.5-3.5-3.5h-7.5c-1.9,0-3.5,1.6-3.5,3.5l0,0 C107.8,103.5,109.3,105,111.2,105"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M118,70.9c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7C119.1,73.6,118,72.4,118,70.9  M119,70.9c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6S119,70.1,119,70.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2.5,113.4c0-2.3,1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1c0,2.3-1.9,4.1-4.1,4.1S2.5,115.6,2.5,113.4  M4.2,113.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5S4.2,112,4.2,113.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.4,94.4H-2.4c-3.1,0-5.5,2.5-5.5,5.5l0,0c0,3.1,2.5,5.5,5.5,5.5h21.9c3.1,0,5.5-2.5,5.5-5.5l0,0 C25,96.9,22.5,94.4,19.4,94.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M101.8,119.3c-3.7-1.6-3.3-1.2-5-5c-1.6,3.7-1.2,3.3-5,5c3.7,1.6,3.3,1.2,5,5 C98.5,120.6,98.1,121,101.8,119.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-17.6,77.9c-2.4-1-2.1-0.8-3.2-3.2c-1,2.4-0.8,2.1-3.2,3.2c2.4,1,2.1,0.8,3.2,3.2 C-19.7,78.7-20,78.9-17.6,77.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-2.1,81.3h-7.5c-1.9,0-3.5,1.6-3.5,3.5l0,0c0,1.9,1.6,3.5,3.5,3.5h7.5c1.9,0,3.5-1.6,3.5-3.5l0,0 C1.3,82.9-0.2,81.3-2.1,81.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-22.4,99.9c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5s-2.5-5.5-5.5-5.5S-22.4,96.9-22.4,99.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M116.2,89.1c0.2,0.2,0.2,0.5,0.1,0.7s-0.3,0.4-0.6,0.4H74L55.8,26.9h42.3c0.2,0,0.4,0.1,0.5,0.2 s0.2,0.3,0.1,0.5L93,58.9c0,0.2,0,0.4,0.1,0.5L116.2,89.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.5,77H49L30.8,13.7h40.1c0.3,0,0.5,0.2,0.6,0.5L89.5,77z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M62.3,65H18.8c-0.3,0-0.5-0.2-0.6-0.5L0.4,2.5C0.3,2.3,0.4,2.1,0.5,2C0.6,1.8,0.8,1.7,1,1.7h42.6 c0.3,0,0.5,0.2,0.6,0.5L62.3,65z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.6,65 49,77 62.3,65  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "70.2,77 74,90.2 89.5,77  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -24,
    y: -25,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1.8-1.8c1.1-1,1.8-2.4,1.8-4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,2.6,1.8,4.8,4.3,5.3l33.6,116.6 c0.1,0.3,0.2,0.5,0.3,0.7l0,0c0.7,1,2,1.3,3,0.8c1.1-0.5,1.6-1.7,1.3-2.9L1.8-1.8z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_84_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M118.6,20H99c-3.2-0.1-5.7-2.7-5.7-5.9c0-3.3,2.7-5.9,5.9-5.9h8.6c3.4,0,6.2-2.8,6.2-6.2 s-2.8-6.2-6.2-6.2H92.9C82.2-13,68.8-18.7,54.1-19.6l0,0c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0c-1.3-0.1-2.5-0.1-3.8-0.1 c-37.4,0-67.7,30.3-67.7,67.7c0,12,3.1,23.2,8.6,33h-0.7c-3.1,0-5.6,2.5-5.6,5.6s2.5,5.6,5.6,5.6H6.3c1.7,0,3,1.4,3,3 c0,1.7-1.4,3-3,3h-8c-1.9,0-3.5,1.5-3.5,3.5c0,1.9,1.5,3.5,3.5,3.5h14.5c9.4,6,20.3,9.7,32.1,10.4l0,0c1.7,0.1,3.3,0.2,5,0.2 c37.4,0,67.7-30.3,67.7-67.7c0-6.3-0.9-12.4-2.5-18.1h3.5c2.7,0,4.9-2.2,4.9-4.9C123.4,22.2,121.2,20,118.6,20"
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-12.6,98.1h-5.2c-1.9,0-3.5,1.5-3.5,3.5s1.5,3.5,3.5,3.5h5.2c1.9,0,3.5-1.5,3.5-3.5 S-10.7,98.1-12.6,98.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M118.6,85.2c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8 C123.4,83,121.2,85.2,118.6,85.2 M118.6,76.7c-2,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7c2.1,0,3.7-1.7,3.7-3.7 C122.3,78.3,120.6,76.7,118.6,76.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-21.3,73.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7C-18.7,72.4-19.9,73.6-21.3,73.6  M-21.3,69.3c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C-19.8,70.1-20.5,69.3-21.3,69.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M-2.4,119.3c3.7-1.6,3.3-1.2,5-5c1.6,3.7,1.2,3.3,5,5c-3.7,1.6-3.3,1.2-5,5C1,120.6,1.4,121-2.4,119.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M100.5,106.6c2.4-1,2.1-0.8,3.2-3.2c1,2.4,0.8,2.1,3.2,3.2c-2.4,1-2.1,0.8-3.2,3.2 C102.6,107.4,102.8,107.6,100.5,106.6"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M65,77.5H5.8c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h68.1c1.2,0,2.2,1,2.2,2.2v3.9 C71.7,74.5,68.7,77.5,65,77.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M64.9,77.5H5.7c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h68.1c1.2,0,2.2,1,2.2,2.2v3.9 C71.6,74.5,68.6,77.5,64.9,77.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M15.4,74.3h55.2c-1.2,1.9-3.3,3.2-5.7,3.2H5.7c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h2.7v6.4 c0,0,0,3.1,3.4,3.1C10.8,74.2,15.4,74.3,15.4,74.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M64.6,65.7H6.2c-2.9,0-5.2-2.3-5.2-5.2v-4.6c0-2.9,2.3-5.2,5.2-5.2h58.4c2.9,0,5.2,2.3,5.2,5.2v4.6 C69.8,63.4,67.5,65.7,64.6,65.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M8.8,50.7H6.2C3.3,50.7,1,53,1,55.9v4.6c0,2.9,2.3,5.2,5.2,5.2h2.6C8.8,65.7,3.4,59.4,8.8,50.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_61_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M66.7,63.2c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9C66.3,62.3,66.7,62.7,66.7,63.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M67.6,61.1c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6C67.3,60.5,67.6,60.8,67.6,61.1 "
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_65_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M5.5,49.4c0,0-5.1,2.8-5.5,5.2s1,4.3,2.8,3.7s1.2-1.5,2.1-2.7s4.8-5.1,5.4-2.5c0.6,2.5,2.2,3.1,3.4,2.5 s1.3-1.8,3.3-1.3c1.9,0.4,4.6-0.1,5.2,1.2c0.6,1.3,0.3,2.7,2.3,2.4c2.1-0.3,1.5-4.5,2.6-4c1.6,0.6-0.2,5.7-0.2,6.5 c0,2.4,4,2.8,4.2,0.1c0.1-1.6-0.4-7.6,2-7.3s2.5-2.1,4.3-1c1.8,1,5.2,3.3,5.6,5.2c0.3,1.3-1.2,6.4,3.7,5.9 c3.3-0.3-0.8-9.7,0.8-10.1c2.6-0.7,1.8,3.2,2.1,4.2c0.3,1.2,2.5,2.1,5.2-0.6c2.7-2.7,7.9-4.2,8.5-3s2.4,0,3.7-0.3 s1.6,3.4,2.8,3.6c1.2,0.1,1.2-0.3,1.2-0.9s-0.3-6.5-3.9-6.5c-2.7,0-13.1-3.3-13.1-3.3L23.3,46C23.3,46,9.9,44.8,5.5,49.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_67_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M24.5,58c-1.9,0.4-1.7-1.2-2.3-2.5C22,55,21.3,55,20.7,54.6c-0.1,0,1.5-1.2,2.2-0.5s0.6,1.4,0.7,1.9 c0.1,0.4,0.9,1.5,1.9,1.3C25.5,57.2,25.2,57.9,24.5,58"
  }))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_69_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M10.8,51.5c-0.9-0.3-1.5,0.8-1.5,0.8c0.5,0,0.8,0.2,1,0.8c0.6,2.5,2.2,3.1,3.4,2.5c0,0-1.4-0.7-1.7-1.9 C11.7,52.5,11.7,51.8,10.8,51.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_71_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M5.5,49.4c0,0-5.1,2.8-5.5,5.2s1,4.3,2.8,3.7C2.8,58.3-1.3,54.9,5.5,49.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M44.4,54.6c0.4,0.7,1,3,0.7,4.9s1.5,3.9,1.5,3.9c-4.9,0.4-3.4-4.6-3.7-5.9c-0.4-1.9-3.8-4.2-5.6-5.2 C37.3,52.2,42.9,51.9,44.4,54.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_75_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M69.7,54.3c-0.8-3.2-2.6-4.6-2.6-4.6c3.6,0,3.9,5.9,3.9,6.5s0,1-1.2,0.9C69.7,57.1,70.2,56.8,69.7,54.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_77_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M51.2,56.2C51,55.6,51.4,53,50,52.5c-1.3-0.4-2.6,0.7-2.6,0.7c2.6-0.7,1.8,3.2,2.1,4.2 c0.3,1.2,2.5,2.1,5.2-0.6C54.7,56.8,51.8,57.7,51.2,56.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_79_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M66.5,42.7c4.4-1,7.1,0.3,5.3,1.5C70,45.4,73.3,46,74.9,49s-5.4,2.1-8.3,2.2c-3,0.1-2.8,1.6-5.4,3.4 c-2.5,1.8-8-2.5-11.1-3.4s-9.2,4.5-12.3,5.8s-6.7-3.4-8.3-5.8c-1.6-2.4-6.8,3-10.3,6.1c-3.4,3.1-5.1-2.8-5.8-4.5 c-0.7-1.6-4.8-0.9-7.7,0.3c-3,1.2-4.4,0.1-5-1.5s-2.5,1.1-4.2-0.1c-2.6-2.1,0.9-4,2.1-4.9C-1,46.3-1,45.9-1,45.4 c0-0.6,0.1-1.1,0.6-1.5C0.5,43,1.7,42.7,3,42.6c1.5-0.1,2.9-0.3,4.4-0.4c6.3-0.4,12.6,0.3,18.9-0.7c0.3,0,0.6-0.1,0.9-0.2 c3.6-0.9,4.5-1.2,6.7-0.6C36.1,41.4,63.9,43.3,66.5,42.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_81_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M72.6,48.9c-0.7,1.1-6.1,0.6-7.7,0.6s-3.6,2.8-5.2,3.6c-1.6,0.7-5.4-1.8-7.3-2.2 c-1.9-0.4-3.4,0.2-3.4,0.2c0.4,0,0.7,0,1.1,0.1c3.1,0.9,8.6,5.2,11.1,3.4s2.4-3.3,5.4-3.4c3-0.1,10,0.7,8.3-2.2 c-1.6-3-4.9-3.6-3.1-4.8c0,0-1.7,0.3-1.6,1.2C70.4,46.3,73.1,48.2,72.6,48.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_83_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M31.7,51.3c-0.4-0.4-0.9-0.8-1.6-0.9c-0.7-0.1-1.4-0.1-2,0.1c0.6-0.1,1,0.1,1.3,0.6 c1.6,2.4,5.2,7.1,8.3,5.8c0.9-0.4,1.9-1,3.1-1.8c-0.3,0.2-0.8,0.2-1.1,0.2c-1.4,0.2-2.8,0.1-4.1-0.6 C34.2,53.9,33,52.5,31.7,51.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_85_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M15.7,52.7c-0.3-0.8-0.8-1.7-1.6-2.2S12.3,50,11.4,50c-1.7,0.2-3.2,0.9-4.5,2c-0.4,0.3-0.8,0.7-1.2,1.1 c1.4-0.5,3-1,4.4-1.2c1.6-0.2,3,0,3.4,0.9c0.7,1.6,2.4,7.6,5.8,4.5C19.2,57.3,17.8,57.9,15.7,52.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_87_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M31.3,40.5c0,0-18,5.3-24.8,5.3c0,0-3.4,0.1-4.3,0s-0.4,0.3,0,0.4c2.5,0.8,5.4,0.6,7.9,0.5 c3.1-0.2,6.2-0.8,9.2-1.7c3.3-1,6.6-1.9,9.7-3.3C29.8,41.4,30.6,41.1,31.3,40.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_89_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M31.4,40.8c-1.6,1.5-3.2,2.9-4.9,4.4c-1,0.9-2.1,1.9-3.2,2.7c-0.8,0.6-2.8,1.1-2.8,2.4 c0.4,0.6,6.4-3.2,9-5.3c1.2-1,2.4-2.3,2.3-3.9c0-0.2-0.1-0.4-0.2-0.3C31.5,40.7,31.5,40.7,31.4,40.8L31.4,40.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_91_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M32.5,40.7c0,0,14,5.8,24.8,5.3c0,0,10.1-0.3,11-0.4c0.9-0.1,0.4,0.3,0,0.4c-2.5,0.8-12.1,1.1-14.6,0.9 c-3.1-0.2-6.2-0.8-9.2-1.7c-3.3-1-6.6-1.9-9.7-3.3C34,41.6,33.2,41.2,32.5,40.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_93_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_93_",
    style: {
      overflow: "visible"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M32.4,41c1.6,1.5,3.2,2.9,4.9,4.4c1,0.9,2.1,1.9,3.2,2.7c0.8,0.6,2.8,1.1,2.8,2.4c-0.4,0.6-6.4-3.2-9-5.3 c-1.2-1-2.4-2.3-2.3-3.9c0-0.2,0.1-0.4,0.2-0.3C32.3,40.8,32.3,40.9,32.4,41C32.4,40.9,32.4,41,32.4,41"
  }))), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_95_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M64.3,47.9H6.5c-1.6,0-3-1.3-3-3v-3.6c0-1.6,1.3-3,3-3h57.8c1.6,0,3,1.3,3,3v3.6 C67.3,46.6,65.9,47.9,64.3,47.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_97_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M8.8,38.4H6.5c-1.6,0-3,1.3-3,3V45c0,1.6,1.3,3,3,3h2.3C8.8,47.9,6.2,43.9,8.8,38.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_99_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M69.4,39.6h-68c-1.2,0-2.2-1-2.2-2.2v-0.6c0-14.4,11.6-26,26-26h20.5c14.4,0,26,11.6,26,26v0.6 C71.7,38.6,70.7,39.6,69.4,39.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_101_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_101_",
    style: {
      overflow: "visible"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M4.1,39.6H1.4c-1.2,0-2.2-1-2.2-2.2v-0.6c0-14.4,11.6-26,26-26C25.2,10.7,2.6,18.2,4.1,39.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_103_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M43,14.6c-0.2,0.2-0.8-0.2-1.3-0.8s-0.7-1.2-0.5-1.4s0.8,0.2,1.3,0.8C43,13.8,43.2,14.4,43,14.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_105_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_105_",
    style: {
      overflow: "visible"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M27.1,14.3c-0.1-0.3,0.3-0.7,1-1.1c0.7-0.4,1.4-0.4,1.5-0.2c0.1,0.3-0.3,0.7-1,1.1 C27.9,14.5,27.3,14.5,27.1,14.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_107_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M36.3,21c-0.3,0-0.5-0.7-0.4-1.4c0.1-0.8,0.3-1.4,0.6-1.4s0.5,0.7,0.4,1.4C36.9,20.4,36.6,21,36.3,21"
  }))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_109_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M54.5,19.3c-0.3,0.1-0.7-0.4-1-1.1s-0.3-1.4,0-1.5s0.7,0.4,1,1.1C54.7,18.5,54.8,19.2,54.5,19.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: -4.4,
    y: 10.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M18.1,19.9c-0.3,0.1-0.7-0.4-1-1.1s-0.3-1.4,0-1.5s0.7,0.4,1,1.1C18.3,19.1,18.4,19.8,18.1,19.9"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_113_",
    x: -24,
    y: -25,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_115_",
    points: "-7,54.2 17,116.3 123.5,75.2 123.5,72.4 100.5,12.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.9,84.1c0,0-1-0.6-0.8-1.9s0.7-1.3,0.2-2.1c-0.6-0.8-1.2-1.3-0.2-1.9s0.8-1.1,1.1-1.7 c0.3-0.6,0.7-1.3,2.1-1.6c1.4-0.3,10.9-2,30.2-1s39-12.3,43.7-19.4c4.7-7,8-16.5,9.9-18.7s2.1-7.5,2-10.2s-0.4-7.5-0.9-8.1 s-0.5-2,0.6-1.7s2.4,1.1,3.2,0.5c0.8-0.6,1.8-0.5,2.4-0.2s1.6-0.9,2.2-0.8c0.5,0,1.2-0.2,0.3,0.9c-0.8,1.1-2,3.2-0.7,8.5 c1.3,5.2,2.7,7.7,5.4,12.1c3.9,6.4,4.8,14.1,2.6,21.3c-3,9.8-10.1,18.9-17.7,25.6c-6.1,5.4-13.2,9.7-21,12.2 c-17.2,5.6-31.6,5-37.9,3.5s-12.6-3.6-17.4-7c0,0-5.5-4.6-7.2-6.4C5.4,84.1,4.9,84.1,4.9,84.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_117_",
    points: "-7,54.2 17,116.3 123.5,75.2 123.5,72.4 100.5,12.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_117_",
    style: {
      overflow: "visible"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M4.1,82.2c-0.2,1.3,0.8,1.9,0.8,1.9s0.5,0,2.2,1.9c1.7,1.8,7.2,6.4,7.2,6.4c4.8,3.4,11,5.4,17.4,7 c6.3,1.5,20.7,2.2,37.9-3.5c7.8-2.5,14.9-6.8,21-12.2c7.6-6.8,14.7-15.8,17.7-25.6c2.2-7.2,1.3-14.9-2.6-21.3 c-2.7-4.4-4.1-6.9-5.4-12.1s-0.1-7.4,0.7-8.5c0.8-1.1,0.2-0.8-0.3-0.9c-0.5,0-1.6,1.1-2.2,0.8c0,0-0.5-0.2-0.9-0.2 s-0.3,0.2-0.3,0.2s0.6,23.4,0.2,27c-0.9,9-5.4,16.8-11.9,23C77.5,73.9,67.1,80,56.5,83.4c-10.8,3.5-21.9,3.1-32.9,1.3 c-4.8-0.8-9.2-2-13.8-3.5c-1.6-0.5-2.8-0.9-4-1.4l-2.1-1.1c0,0-0.1,0.3,0.3,0.8c0.4,0.6,0.9,0.7,0.7,1 C4.4,80.8,4.1,82.2,4.1,82.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_119_",
    points: "-7,54.2 17,116.3 123.5,75.2 123.5,72.4 100.5,12.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_119_",
    style: {
      overflow: "visible"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M101,16.2c1-0.9,0.4-1-0.1-0.9c-0.7,0-1.8,1.2-2.4,0.9c-0.6-0.3-1.6-0.4-2.4,0.2s-2.1-0.2-3.2-0.5 c-1.1-0.3-1.3,1.2-0.6,1.7c0,0,1.2,0.5,2.8,0.2c1.6-0.4,2.2-0.8,3-0.7C98.9,17.2,100.4,16.7,101,16.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_121_",
    points: "-7,54.2 17,116.3 123.5,75.2 123.5,72.4 100.5,12.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M7.3,75c-1.4,0.3-1.9,1-2.1,1.6c-0.3,0.6-0.1,1.1-1.1,1.7c-1.2,0.7,0,1.2,0.1,2.2 c0.1,0.9,0.2,0.4-0.1,1.8c-0.2,1.3,0.8,1.9,0.8,1.9s1-2.8,1.4-4.1C6.5,78.7,7.3,75,7.3,75"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 49.6,
    cy: 49.7,
    r: 47.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Water_x5F_Glass_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_123_",
    x: 27,
    y: 24.5,
    width: 45.2,
    height: 54.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st64"
  }, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_125_",
    x: 27,
    y: 24.5,
    width: 45.2,
    height: 54.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_125_",
    style: {
      overflow: "visible"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M63.8,79.4H35.4c-1.8,0-3.3-1.4-3.3-3.2l-5-50.1c0-0.9,0.7-1.6,1.7-1.6h41.8c0.9,0,1.7,0.7,1.7,1.6l-5,50.1 C67.2,78,65.7,79.4,63.8,79.4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M67.6,71.9l-0.4,4.3c0,1.8-1.5,3.2-3.3,3.2H50.5H35.4c-1.8,0-3.3-1.4-3.3-3.2l-5-50.1 c0-0.9,0.7-1.6,1.7-1.6h6.5l4.6,40.5C39.8,65.1,55.2,81.1,67.6,71.9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M66.4,42.1l-3.3,31.2c0,0.9-0.7,1.7-1.7,1.7H37.8c-0.9,0-1.7-0.7-1.7-1.7l-3.3-30.9c0,0,7.3-2.9,15.4,0.8 C60.2,48.8,66.4,42.1,66.4,42.1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M48.3,75H37.8c-0.9,0-1.7-0.7-1.7-1.7l-3.3-30.9c0,0,1.7-0.7,4.4-1c0.1,1.4,0.3,2.8,0.4,4.1 c0.3,3,0.6,6.1,1,9.1c0.3,3,0.7,6.1,1,9.1c0.3,2.1,0.3,4.1,1.5,6c0.8,1.4,2,2.6,3.4,3.5c0.6,0.4,1.1,0.7,1.8,0.9 C46.8,74.5,47.7,75,48.3,75"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M61.4,58.4c0.1,0.5,0.2,0.9,0.8,1c0.5,0,0.9-0.3,1-0.8l0.9-8.9c0.1-1.1-0.7-2.1-1.9-2.2 c-1-0.1-1.9,0.5-2.2,1.5c-0.2,0.5,0,1.1,0.1,1.7c0.3,1.7,0.6,3.3,0.8,5c0.1,0.8,0.3,1.6,0.4,2.5C61.3,58.1,61.4,58.2,61.4,58.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.79ef9a155965bd74bb754fd940dd3011.svg";
export { ForwardRef as ReactComponent };